import { List, Skeleton } from "@mui/material";
import { useToast } from "@src/appV2/lib";
import pluralize from "pluralize";

import { useGetMultipleChoiceAggregates } from "../../api/useGetMultipleChoiceAggregates";
import { AggregateItem } from "./AggregateItem";

interface MultipleChoiceAggregatesProps {
  workplaceId: string;
}

export function MultipleChoiceAggregates(props: MultipleChoiceAggregatesProps) {
  const { workplaceId } = props;
  const { showErrorToast } = useToast();

  const { data: multipleChoiceAggregates = [], isLoading } = useGetMultipleChoiceAggregates(
    workplaceId,
    {
      onError: () => {
        showErrorToast("Something went wrong while loading aggregates");
      },
    }
  );

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        width="100%"
        height={100}
        aria-label="Loading Multiple Choice Aggregates"
      />
    );
  }

  return (
    <List
      sx={{
        width: "100%",
        padding: 0,
        "li:last-child": {
          paddingY: 0,
        },
      }}
    >
      {multipleChoiceAggregates.map((aggregate) => {
        const { id, attributes } = aggregate;
        return (
          <AggregateItem
            key={id}
            headerText={attributes.text}
            actionText={pluralize("response", attributes.repliesCount, true)}
            questionTags={attributes.question.tags}
          />
        );
      })}
    </List>
  );
}
